import { render, staticRenderFns } from "./onlinesystem.vue?vue&type=template&id=0472a42d&scoped=true&"
import script from "./onlinesystem.vue?vue&type=script&lang=js&"
export * from "./onlinesystem.vue?vue&type=script&lang=js&"
import style0 from "./onlinesystem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./onlinesystem.vue?vue&type=style&index=1&id=0472a42d&scoped=true&lang=scss&"
import style2 from "./onlinesystem.vue?vue&type=style&index=2&id=0472a42d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472a42d",
  null
  
)

export default component.exports